<template>
  <div class="home">
    <InventoryList v-show="listView" @newInventory="onClickNewFromList" @newInventoryUnit="onClickNewUnitFromList" @editInventory="onClickEditFromList" :scroll="corY" ref="refreshList"/>
    <InventoryForm v-show="formView" :inventory="inventory" :purchasing="purchasing" @backClicked="onBackChild" @backSaveClicked="onBackSaveChild" />
  </div>
</template>

<script>
// @ is an alias to /src
import axios from 'axios'
import { mapState } from 'vuex'
import InventoryList from '@/components/inventory/InventoryList.vue'
import InventoryForm from '@/components/inventory/InventoryForm.vue'
import { inventoryUrl, purchasingUrl, getHeader } from '../config'

export default {
  name: 'Inventory',
  components: {
    InventoryForm,
    InventoryList
  },
  data () {
    return {
      corX: 0,
      corY: 0,
      listView: true,
      formView: false,
      urlHistory: null,
      ref: null,
      purchasing: {
        id: null,
        purchasing_no: null,
        purchasing_date: null,
        purchasing_due_date: null,
        ref_no: null,
        branch_no: null,
        vendor_no: null,
        subtotal: '0',
        tax_id: null,
        tax: '0',
        discount: '0',
        total: '0',
        delivery_cost: '0',
        deliver_no: null,
        status: null,
        branch: null,
        vendor: null,
        details: [{
          purchasing_no: null,
          purchasing_date: null,
          branch_no: null,
          product_no: null,
          product: null,
          description: null,
          qty: null,
          qty_done: null,
          uom_id: null,
          price: '0',
          tax_id: null,
          tax: '0',
          discount: '0',
          total: '0',
          edit: false,
          uomList: [{
            id: null,
            name: null,
            category_id: null,
            category: null,
            type_id: null,
            ratio: null,
            active: null,
            cost: '0'
          }]
        }]
      },
      inventory: {
        id: null,
        inventory_no: null,
        type_id: null,
        inventory_date: new Date().toLocaleString(),
        purchasing_no: null,
        purchasing_id: null,
        warehouse_no: null,
        total_detail: null,
        status: null,
        ext_no: null,
        branch_no: null,
        user_id: null,
        user_approve: null,
        lock: false,
        ext_no2: null,
        vendor_no: null,
        details: [{
          id: null,
          inventory_no: null,
          qty_demand: null,
          qty_done: null,
          serial_number: null,
          product_no: null,
          product_sku: null,
          warehouse_no: null,
          uom_id: null,
          uomList: [{
            id: null,
            name: null,
            category: null
          }],
          inventory_date: null,
          branch_no: null,
          expired_date: null,
          status: null,
          sec_serial_number: null,
          internal_no: null,
          cost: '0',
          total_cost: '0',
          vendor_no: null,
          receive_finish: null,
          adjust_type: null
        }],
        logs: [{
          id: null,
          log_date: null,
          ref_no: null,
          user_id: null,
          user: null,
          description: null
        }],
        purchasing: [{
          id: null,
          purchasing_no: null,
          purchasing_date: null,
          purchasing_due_date: null,
          ref_no: null,
          branch_no: null,
          vendor_no: null,
          subtotal: null,
          tax_id: null,
          tax: null,
          discount: null,
          total: null,
          delivery_cost: null,
          deliver_no: null,
          status: null,
          type_id: null,
          lock: false,
          company_no: null,
          term_due_id: null,
          ext_no: null,
          sp_no: null,
          details: [{
            id: null,
            purchasing_no: null,
            purchasing_date: null,
            branch_no: null,
            product_no: null,
            product: null,
            product_sku: null,
            description: null,
            qty: null,
            qty_done: null,
            uom_id: null,
            price: null,
            tax_id: null,
            tax: null,
            discount: null,
            total: null,
            company_no: null
          }]
        }]
      }
    }
  },
  computed: {
    ...mapState({
      uomList: state => state.uom.uomList,
      authUser: state => state.users.authUser,
      warehouseList: state => state.warehouses.warehouseList
    })
  },
  mounted () {
    this.$store.dispatch('getTermDueList')
    this.$store.dispatch('getVendorList')
    this.$store.dispatch('getPurchasingTypeList')
    this.$store.dispatch('getTaxList')
    this.$store.dispatch('getInventoryTypeList')
    this.$store.dispatch('getWarehouseList')
    this.$store.dispatch('getUomList')
    this.$store.dispatch('getRowTable')
    this.$store.dispatch('getProductCategoryList')
    this.$store.dispatch('getCompanyList')
    var payload = {
      status: 'order'
    }
    this.$store.dispatch('getProductListSelect', payload)
    var form = this.$route.query.form
    var purchasing = this.$route.query.purchasing
    if (form === 'true') {
      if (purchasing !== null) {
        this.getPurchasing(purchasing)
        this.onClickNewFromList()
      }
    }
  },
  methods: {
    onClickNewUnitFromList: function () {
      this.listView = false
      this.formView = true
      this.inventory = {
        id: null,
        inventory_no: null,
        type_id: 'unit',
        inventory_date: new Date().toLocaleString(),
        purchasing_no: null,
        purchasing_id: null,
        warehouse_no: null,
        total_detail: null,
        status: null,
        ext_no: null,
        branch_no: null,
        user_id: null,
        user_approve: null,
        lock: false,
        ext_no2: null,
        vendor_no: null,
        details: [{
          inventory_no: null,
          qty_demand: 0,
          qty_done: 0,
          serial_number: null,
          product_no: null,
          product_sku: null,
          warehouse_no: null,
          uom_id: null,
          uomList: [{
            id: null,
            name: null,
            ratio: '0',
            category: null
          }],
          inventory_date: null,
          branch_no: null,
          expired_date: null,
          status: null,
          sec_serial_number: null,
          internal_no: null,
          cost: '0',
          total_cost: '0',
          vendor_no: null,
          receive_finish: false,
          adjust_type: 'increase'
        }],
        logs: [{
          id: null,
          log_date: null,
          ref_no: null,
          user_id: null,
          user: null,
          description: null
        }],
        purchasing: [{
          id: null,
          purchasing_no: null,
          purchasing_date: null,
          purchasing_due_date: null,
          ref_no: null,
          branch_no: null,
          vendor_no: null,
          subtotal: null,
          tax_id: null,
          tax: null,
          discount: null,
          total: null,
          delivery_cost: null,
          deliver_no: null,
          status: null,
          type_id: null,
          lock: false,
          company_no: null,
          term_due_id: null,
          ext_no: null,
          sp_no: null
        }]
      }
    },
    onClickNewFromList: function () {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      var warehouse = this.warehouseList.find(d => d.company_no === this.authUser.company_no)
      this.inventory = {
        id: null,
        inventory_no: null,
        type_id: 'regular',
        inventory_date: new Date().toISOString(),
        purchasing_no: null,
        purchasing_id: null,
        warehouse_no: warehouse ? warehouse.warehouse_no : null,
        total_detail: null,
        status: null,
        ext_no: null,
        branch_no: null,
        company_no: this.authUser.company_no,
        user_id: null,
        user_approve: null,
        lock: false,
        vendor_no: null,
        ext_no2: null,
        details: [{
          inventory_no: null,
          qty_demand: 0,
          qty_done: 0,
          serial_number: null,
          product_no: null,
          product_sku: null,
          warehouse_no: null,
          uom_id: null,
          uomList: [{
            id: null,
            name: null,
            ratio: '0',
            category: null
          }],
          inventory_date: null,
          branch_no: null,
          expired_date: null,
          status: null,
          sec_serial_number: null,
          internal_no: null,
          cost: '0',
          total_cost: '0',
          vendor_no: null,
          receive_finish: false,
          adjust_type: 'increase'
        }],
        logs: [{
          id: null,
          log_date: null,
          ref_no: null,
          user_id: null,
          user: null,
          description: null
        }],
        purchasing: []
      }
    },
    onClickEditFromList: function (value) {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.inventory = value
      this.listView = false
      this.formView = true
    },
    async onBackChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
    },
    async onBackSaveChild () {
      this.listView = true
      this.formView = false
      this.$refs.refreshList.refreshInventory()
    },
    getPurchasing: function (id) {
      console.log(purchasingUrl + '/' + id)
      axios.get(purchasingUrl + '/' + id, { headers: getHeader() })
        .then(response => {
          var purchasing = response.data.data
          console.log(purchasing)
          // var pDetails = response.data.data.details
          this.purchasing = response.data.data
          this.inventory.purchasing_no = response.data.data.purchasing_no
          axios.post(inventoryUrl + '/purchasing', { purchasing: purchasing.purchasing_no }, { headers: getHeader() })
            .then(response => {
              this.inventory = response.data.data
            })
            .catch(error => {
              console.log(error.response)
            })
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>
